// Portal-wide demo constants for the notification POC.

// The employee whose in-app feed drives the header bell. Matches the Maker
// in the POC staff table (โจทย์ LC ข้อ 1) and the seeded UMS stub user.
export const DEMO_EMPLOYEE_SUBSCRIBER = 'EMP-5401879'

// Polling cadence (ms). SSE, when connected, only accelerates invalidation —
// polling remains the correctness backstop.
export const FEED_POLL_FAST = 5_000
export const FEED_POLL_SLOW = 30_000
export const TRACKER_POLL = 2_000

// Customer / merchant app origins. The engine stores each notification's
// deep-link as a RELATIVE path (e.g. /gov-pocket/transaction?txn=… , /slip/…)
// which is correct inside each app's own router and WebView. The standalone
// /inbox page, however, can be opened as a plain browser tab on the
// notification-center domain — so it upgrades a relative path to the recipient
// app's full URL (MERCH-* → merchant app, else customer app) so a tap opens the
// real transaction instead of 404-ing on this domain.
export const CUSTOMER_APP_ORIGIN = 'https://customer-mobile.promptserve.tech'
export const MERCHANT_APP_ORIGIN = 'https://merchant-mobile.promptserve.tech'

// resolveDeepLink makes a feed item's deepLink safe for an <a href>. Absolute
// URLs (http(s):// or any scheme like baacmobile://) pass through untouched; a
// relative path is prefixed with the recipient's app origin.
export function resolveDeepLink(deepLink: string, subscriber: string): string {
  if (deepLink === '') return ''
  if (/^[a-z][a-z0-9+.-]*:/i.test(deepLink)) return deepLink // http(s)://, baacmobile://, mailto: …
  if (!deepLink.startsWith('/')) return deepLink
  const origin = subscriber.toUpperCase().startsWith('MERCH')
    ? MERCHANT_APP_ORIGIN
    : CUSTOMER_APP_ORIGIN
  return origin + deepLink
}
